import type { Deal } from '@/types'

// Travelpayouts marker — single marker covers flights, hotels, activities
const MARKER = import.meta.env.VITE_TRAVELPAYOUTS_MARKER || '729556'

export function buildAffiliateLink(deal: Deal): string {
  if (deal.network === 'direct' && deal.baseUrl) return deal.baseUrl
  try {
    const url = new URL(deal.baseUrl)
    // Travelpayouts unified marker
    url.searchParams.set('marker', MARKER)
    url.searchParams.set('utm_source', 'passage_imaginarium')
    url.searchParams.set('utm_medium', 'affiliate')
    url.searchParams.set('utm_campaign', `passage_${deal.category}`)
    return url.toString()
  } catch { return deal.baseUrl }
}

export function openDeal(deal: Deal, destination: string): void {
  // Client-side tracking (Phase 2: POST to /api/affiliate/click)
  const event = { dealTitle: deal.title, network: deal.network, destination, timestamp: new Date().toISOString() }
  const log = JSON.parse(sessionStorage.getItem('passage_affiliate_clicks') || '[]')
  log.push(event); sessionStorage.setItem('passage_affiliate_clicks', JSON.stringify(log))
  if (import.meta.env.VITE_APP_ENV === 'development') console.info('[Passage Affiliate]', event)
  window.open(buildAffiliateLink(deal), '_blank', 'noopener,noreferrer')
}

export const NETWORK_LABELS: Record<string, string> = {
  skyscanner: 'Skyscanner', booking_com: 'Booking.com', viator: 'Viator',
  get_your_guide: 'GetYourGuide', klook: 'Klook', airbnb: 'Airbnb', direct: 'Direct Partner',
}

export const NETWORK_COLORS: Record<string, string> = {
  skyscanner: '#0770E3', booking_com: '#003580', viator: '#142B51',
  get_your_guide: '#FF5533', klook: '#FF5722', airbnb: '#FF5A5F', direct: '#8B4513',
}
